import Transfer from './transfer';
import './styles/index.scss';
Transfer.displayName = 'Transfer';
export default Transfer;
